// eslint-disable-next-line
// @ts-nocheck
import { getResource } from 'core';
import { itemType } from 'metadata';

const getAccessFieldMetadata = () => {
	return {
		type: 'item',
		itemTypeName: 'Identity',
		label: getResource('toc_editor.access'),
		required: true
	};
};

const getImageFieldMetadata = () => {
	return {
		type: 'image',
		cssClass:
			'toc-editor__form-image-field toc-editor__form-image-field_distant',
		label: getResource('toc_editor.icon')
	};
};

const getLabelFieldMetadata = (state) => {
	const { languages, defaultLanguageCode } = state;
	return {
		defaultLanguageCode,
		label: getResource('toc_editor.label'),
		languages,
		required: true,
		type: 'multiLingual'
	};
};

const getItemTypeFieldMetadata = () => {
	return {
		itemTypeName: 'ItemType',
		label: getResource('toc_editor.itemtype'),
		required: true,
		type: 'item'
	};
};

const getFormFieldMetadata = () => {
	return {
		itemTypeName: 'Form',
		label: getResource('toc_editor.form'),
		required: true,
		type: 'item'
	};
};

const getSortFieldMetadata = (state) => {
	const { sortingTypesList: options = [] } = state;
	return {
		label: getResource('toc_editor.sort'),
		type: 'select',
		options
	};
};

const getStartPageFieldMetadata = () => {
	return {
		label: getResource('toc_editor.start_page'),
		required: true,
		type: 'text'
	};
};

const getPageParametersFieldMetadata = () => {
	return {
		label: getResource('toc_editor.parameters'),
		type: 'text'
	};
};

const getItemFieldMetadata = (state, stateData) => {
	const { selectedId } = state;
	const relshipItem = stateData.get(selectedId);
	const relatedItem = stateData.get(relshipItem['related_id']);
	const { itemTypeId } = relatedItem['additional_data'];
	const itemTypeName = itemType.getItemTypeName(itemTypeId);
	return {
		itemTypeName,
		label: getResource('toc_editor.item'),
		required: true,
		type: 'item'
	};
};

const propertyMetadataGenerators = {
	access: getAccessFieldMetadata,
	label: getLabelFieldMetadata,
	image: getImageFieldMetadata,
	itemType: getItemTypeFieldMetadata,
	startPage: getStartPageFieldMetadata,
	parameters: getPageParametersFieldMetadata,
	form: getFormFieldMetadata,
	sort: getSortFieldMetadata,
	item: getItemFieldMetadata
};

export const getFormMetadata = (stateData, state, order = []) => {
	const { selectedId, viewAs } = state;
	const relshipItem = stateData.get(selectedId);
	const disabled = viewAs || relshipItem?.['@aras.action'] === 'delete';
	return order.reduce((result, property) => {
		const metadata = propertyMetadataGenerators[property](state, stateData);
		result[property] = { ...metadata, disabled };
		return result;
	}, {});
};
